"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTimePassed = exports.timeAgo = exports.getMediaDuration = exports.getDurationSymbols = exports.differenceInMilliseconds = exports.isValid = exports.parse = exports.parseISO = exports.isAfter = exports.format = void 0;
const date_fns_1 = require("date-fns");
var date_fns_2 = require("date-fns");
Object.defineProperty(exports, "format", { enumerable: true, get: function () { return date_fns_2.format; } });
Object.defineProperty(exports, "isAfter", { enumerable: true, get: function () { return date_fns_2.isAfter; } });
Object.defineProperty(exports, "parseISO", { enumerable: true, get: function () { return date_fns_2.parseISO; } });
Object.defineProperty(exports, "parse", { enumerable: true, get: function () { return date_fns_2.parse; } });
Object.defineProperty(exports, "isValid", { enumerable: true, get: function () { return date_fns_2.isValid; } });
Object.defineProperty(exports, "differenceInMilliseconds", { enumerable: true, get: function () { return date_fns_2.differenceInMilliseconds; } });
function getDurationSymbols(durationMs) {
    const durationSeconds = Math.floor(durationMs / 1000);
    return {
        ms: durationMs % 1000,
        MS: durationMs,
        s: durationSeconds % 60,
        S: durationSeconds,
        m: Math.floor((durationSeconds % 3600) / 60),
        M: Math.floor(durationSeconds / 60),
        h: Math.floor(durationSeconds / 3600),
    };
}
exports.getDurationSymbols = getDurationSymbols;
function getMediaDuration(durationMs) {
    const durationSymbols = getDurationSymbols(durationMs);
    const hoursString = durationSymbols.h === 0 ? "" : `${durationSymbols.h}:`;
    const minutesString = durationSymbols.m === 0
        ? "00:"
        : durationSymbols.h < 1 || durationSymbols.m >= 10
            ? `${durationSymbols.m}:`
            : "0" + `${durationSymbols.m}:`;
    const secondsString = durationSymbols.s < 10 ? "0" + `${durationSymbols.s}` : `${durationSymbols.s}`;
    return `${hoursString}${minutesString}${secondsString}`;
}
exports.getMediaDuration = getMediaDuration;
function timeAgo(time, { addSuffix, locale } = { addSuffix: false }) {
    return date_fns_1.formatDistanceToNowStrict(typeof time === "string" ? date_fns_1.parseISO(time) : date_fns_1.toDate(time), {
        addSuffix,
        locale,
    });
}
exports.timeAgo = timeAgo;
function toTimePassed(totalMs) {
    const durationSymbols = getDurationSymbols(totalMs);
    const hoursString = durationSymbols.h < 10 ? "0" + durationSymbols.h : durationSymbols.h.toString();
    const minutesString = durationSymbols.m < 10 ? "0" + durationSymbols.m : durationSymbols.m.toString();
    const secondsString = durationSymbols.s < 10 ? "0" + durationSymbols.s : durationSymbols.s.toString();
    return `${hoursString === "00" ? "" : hoursString + ":"}${minutesString}:${secondsString}`;
}
exports.toTimePassed = toTimePassed;
//# sourceMappingURL=TimeHelpers.js.map